import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';
import { ChatService } from 'src/app/___LOGIC/__common/chat.service';


@Component({
  selector: 'app-client-cards',
  templateUrl: './client-cards.component.html',
  styleUrls: ['./client-cards.component.css']
})
export class ClientCardsComponent implements OnInit {

  constructor(private resolver: ResolverService,private router: Router,private chatService: ChatService) {}

  ngOnInit(): void {
  }

  getClientDashboardData(){
    return this.resolver.resolveList('getClientDashboardData');
  }

  getClientCardsByStatus(p_status){
    let res = [];
    if(this.getClientDashboardData() && this.getClientDashboardData().length>0){
      for(let clientCard of this.getClientDashboardData()){
        if(clientCard.status === p_status){
          res.push(clientCard);
        }
      }
    }
    return res;
  }

  goToPage(page){
    this.router.navigateByUrl(page);
  }

  openClientChat(clientCard){
    this.chatService.setSelectedClientChat(clientCard.id);
    this.router.navigateByUrl('client/interactions');
  }

}
